<template>
  <div class="mt-4">
    <div class="flex items-center mb-3">
      <div class="flex-1" style="height: 1px;background-color: rgba(0,0,0,0.06);"></div>
      <div class="ml-2 mr-2 text-small text-theme-black-450"> &#8595 根据当前配置自动计算 &#8595 </div>
      <div class="flex-1" style="height: 1px;background-color: rgba(0,0,0,0.06);"></div>
    </div>
    <div class="flex mb-2 items-center">
      <p style="width:57px;white-space: nowrap;" class="mr-2 text-medium text-theme-black-850 leading-22 font-normal">指标数值：</p>
      <div v-if="showProgress" class="mr-2 wrap-refresh-progress">
        <el-progress :percentage="refreshProgress"></el-progress>
      </div>
      <div class="flex items-center text-medium text-theme-black-650 mr-2" v-else>
        <span v-show="tableData && tableData.calcAt">(数据截至：{{tableData && tableData.calcAt?tableData.calcAt:''}})</span>
        <i class="iconfont icon-shuaxin text-medium text-theme ml-1" @click="updataIndexData"></i>
      </div>
    </div>
    <div class="box-border" v-if="tableData">
      <div class="col-header flex relative">
        <table border='1' cellspacing='0' cellpadding="0">  
        <!-- 列头 -->
        <tr>
          <td height="44" align="center" class="stick-one">
            <div class="flex items-center justify-center">
              <span>指标</span>
            </div>
          </td>
          <td v-for="(item) in tableData.colHeaders" :key="item.name" height="44" align="center" class="stick-col-head">
            <div class="flex items-center justify-center">
              <span>{{item.name}}</span>
            </div>
          </td>
        </tr>
        <tr v-for="(item,index) in tableData.rowHeaders" :key="index">
          <!-- 行头 -->
          <td height="44" align="center" class="stick-row-head">
            <span>{{item.name}}</span>
          </td>
          <!-- 展示数据 -->
          <td height="44" align="center" v-for="(item,index1) in tableData.data[index]" :key="index1" :style="{width:'153px'}">{{item}}</td>
        </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StatisticalTables from './StatisticalTables.vue';
import { calcCell, calcCol, calcRow, calcLook, getCalcProgress, getCalcResultTable } from '@/api/index-statistics'

export default {
  name: 'PreviewCalcul',
  components: {StatisticalTables},
  data() {
    return {
     tableData:null,
     showProgress:false,
     refreshProgress:0,
     refreshTimer:null,
     checkColArr:[],
     checkRowArr: [],
    }
  },
  props: {
    id:{
      type:Number,
      default:0
    },
    calculType:{
      type:String,
      default:''
    },
    calcResultTable:{
      type:Object | null,
      default: null
    },
    indicatorDimensionIds:{
      type:Array,
      default: []
    },
    timeDimensionIds:{
      type:Array,
      default: []
    }
  },
  watch: {
    refreshProgress(v){
      if(v && v == 100) {
        this.getTableData()
      }
    },
    calcResultTable(v){
      this.tableData=v
    }
  },
computed:{

},
  created(){
  },
  mounted(){
    this.tableData=this.calcResultTable
  },
  methods:{
    // 更新
    async updataIndexData(){
        let res
      // 调用开始计算
      if(this.calculType=='look'){
        let id=String(this.id)
        res=await calcLook(id)
      }else if(this.calculType=='cell'){
        const data=this.$parent.submitCell(false)
        if(!data) return
        res=await calcCell(data)
      }else if(this.calculType=='row'){
        const data= this.$parent.submitBatch(false)
        if(!data) return
        res=await calcRow(data)
      }
      else if(this.calculType=='col'){
        const data= this.$parent.submitBatch(false)
        if(!data) return
        res=await calcCol(data)
      }
      if(res.data.code == 0) {
          this.refreshVersion = res.data.data
          this.refreshProgress = 0
          this.showProgress = true
          this.refreshTimer = setInterval(() => {
            this.getProgress()
          },1000)
        }else{
          this.$message.error(res.data.msg || '更新失败')
        }
    },
    getProgress(){
      getCalcProgress({key:this.refreshVersion}).then(res=>{
        this.refreshProgress = res.data.data?.progress
        this.refreshVersion = res.data.data?.key
        if(res.data.code == 0){
          if(res.data.data.isFinished){
            this.showProgress = false
            clearInterval(this.refreshTimer)
          }
        }else if(res.data.code != 0){
          this.showProgress = false
          clearInterval(this.refreshTimer)
          this.$message.error(res.data.msg||'刷新失败!')
        }
      }).catch(err => {
        this.$message.error('刷新失败!')
        clearInterval(this.refreshTimer)
      })

    },
    getTableData(){
      let data={
        indicatorDimensionIds:this.indicatorDimensionIds,
        timeDimensionIds:this.timeDimensionIds,
      }
      getCalcResultTable(data).then(res=>{
        this.tableData=res.data.data
        this.calcAt=res.data.data?.calcAt
      })

    },
  }
}
</script>

<style lang="scss" scoped>
.wrap-refresh-progress{
  .el-progress.el-progress--line{
    width: 200px !important;
    ::v-deep .el-progress-bar{
      padding-right: 70px;
      margin-right: -75px;
    }
  }
}
.col-header{
  width: 100%;
  box-sizing: border-box;
  // max-height: calc(100vh - 248px);
  overflow-x: auto;
}
table{
  border-color:#e7e9eb;
  border-collapse: collapse;  
}
td {
  border: 1px solid #e7e9eb;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  min-width: 153px;
  background-color: #fff;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.stick-col-head{
  position: sticky;
  top: 0;
  left: 144px;
  background-color: #f5f5f5;
}
.stick-row-head{
  position: sticky;
  left: 0;
  top: 44px;
  background-color: #f5f5f5;
  z-index: 99;
}
.stick-one{
  background-color: #f5f5f5;
  position: sticky;
  left: 0;
  top: 0;
}
.noborder{
  // border: none;
}
.left-right-border{
  border-left: 1px solid #e7e9eb;
  border-right: 1px solid #e7e9eb;
}
.activeSort{
  @apply text-theme;
}

</style>
